import React from "react";
import Testimonials from "./Testimonials";

type Plan = {
  title: string;
  price: string;
  description: string;
  features: string[];
  active?: boolean;
};

const plans: Plan[] = [
  {
    title: "Basic Plan",
    price: "$400",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    features: [
      "Free Consultation",
      "Basic Therapy",
      "Free E-Book",
      "24/7 Support",
    ],
  },
  {
    title: "Basic Plan",
    price: "$400",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    features: [
      "Free Consultation",
      "Basic Therapy",
      "Free E-Book",
      "24/7 Support",
    ],
  },
  {
    title: "Basic Plan",
    price: "$400",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    features: [
      "Free Consultation",
      "Basic Therapy",
      "Free E-Book",
      "24/7 Support",
    ],
    active: true,
  },
];

const Pricing = () => {
  return (
    <div className="py-6 w-full bg-gradient-to-b from-[#0CACDE]/20 to-[#0CACDE]/30 px-4 sm:px-12 jost-regular sm:py-20 mx-4 sm:mx-12 flex flex-col gap-5 sm:gap-10 justify-center items-center">
      <div className="flex flex-col items-center gap-4">
        <h3 className="jost-regular text-primary text-xl sm:text-2xl py-4 uppercase">
          Pricing plan
        </h3>
        <h1 className="jost-regular !font-[500] text-3xl text-center sm:text-5xl">
          Affordable Pricing
          <span className="italic mx-3 tracking-[-3px] font-eiko-thin text-primary">
            Packages
          </span>
        </h1>
      </div>
      <div className="flex flex-col md:flex-row justify-center items-center w-full">
        {plans.map((item, index) => (
          <div
            className={`max-w-[450px] w-full px-7 bg-white py-10 ${item.active === true && "!bg-black text-white"}`}
            key={index}
          >
            <h2 className="text-2xl sm:text-3xl jost-regular">
              {item.price}{" "}
              <span className="text-lg sm:text-xl !font-light">/Package</span>
            </h2>
            <h3 className="text-xl sm:text-2xl jost-regular mt-4">
              {item.title}
            </h3>
            <p className="opacity-50 mt-4 max-w-60">{item.description}</p>
            <hr className="my-4" />
            <div className="flex flex-col gap-4">
              <h3 className="text-lg sm:text-xl jost-regular mt-4 uppercase">
                What's included
              </h3>
              <ul className="flex flex-col gap-2">
                {item.features.map((feature, index) => (
                  <li className="flex items-center gap-2" key={index}>
                    <span className="text-primary">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="15"
                        viewBox="0 0 21 15"
                        fill="none"
                      >
                        <path
                          opacity="0.5"
                          d="M1 7L7.5 13.5L19.5 1.5"
                          stroke={"#0D9447"}
                          stroke-width="2"
                        />
                      </svg>
                    </span>{" "}
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
            <button
              className={`w-full ${item.active === true ? "bg-primary" : "bg-black"} rounded-full text-white py-2 mt-10 hover:${item.active === true ? "bg-black" : "bg-primary"}`}
            >
              GET STARTED
            </button>
          </div>
        ))}
      </div>
      {/* <Testimonials /> */}
    </div>
  );
};

export default Pricing;
